import Vue from "vue";
import Website from "./Website.vue";

import "bootstrap";
import "popper.js";
import $ from "jquery";

Vue.config.productionTip = false;

$.fn.isInViewport = function() {
  let elementTop = $(this).offset().top;
  let elementBottom = elementTop + $(this).outerHeight();
  let viewportTop = $(window).scrollTop();
  let viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

new Vue({
  render: h => h(Website)
}).$mount("#website");

$(window).on("resize scroll", function() {
  let distanceFromTop = $(window).scrollTop();
  // NavBar change
  if (distanceFromTop > 70) {
    $("#whiteLogo")
      .removeClass()
      .addClass("d-none");
    $("#blackLogo")
      .removeClass()
      .addClass("d-block");
    $("#mainNav")
      .removeClass(["bg-transparent", "navbar-dark"])
      .addClass(["bg-white", "navbar-light"]);
  } else {
    $("#whiteLogo")
      .removeClass()
      .addClass("d-block");
    $("#blackLogo")
      .removeClass()
      .addClass("d-none");
    $("#mainNav")
      .removeClass(["bg-white", "navbar-light"])
      .addClass(["bg-transparent", "navbar-dark"]);
  }
  // SlideShow Text
  if (distanceFromTop > 1) {
    $("#introText")
      .removeClass("animate-off")
      .addClass("animate-on");
  } else {
    $("#introText")
      .removeClass("animate-on")
      .addClass("animate-off");
  }
});
$(window).ready(function() {
  $("#landingText")
    .removeClass("animate-off")
    .addClass("animate-on");
});
